module.exports = __webpack_public_path__ + "static/img/027_TO8_1520_og.dc2d52e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/027_TO8_1520_og.jpg
// module id = jZK3
// module chunks = 0